import axios from 'axios';
import { logIn } from './user-actions';
import { recoverAccountDataActions } from './recoverAccount-slice';

export const getUserAlias = (filter, aliasType) => {
  return async dispatch => {
    let userAlias = await axios.post(
      `${process.env.REACT_APP_API_PATH_MAYAHII_USER_INFO}/auth/alias/check`,
      {
        filter,
        aliasType
      }
    );
    if (userAlias.data.length > 0) {
      dispatch(
        recoverAccountDataActions.alias({
          alias: userAlias.data
        })
      );
    } else {
      dispatch(
        recoverAccountDataActions.alias({
          alias: 'noUser'
        })
      );
    }
  };
};

export const getPasswordNotification = alias => {
  return async dispatch => {
    let recoverPassword = await axios.post(
      `${process.env.REACT_APP_API_PATH_USER}/user/password/recover`,
      {
        alias
      }
    );
    if (recoverPassword.data.message === 'SC_OK') {
      dispatch(
        recoverAccountDataActions.code({
          code: recoverPassword.data.result
        })
      );
    }
  };
};

export const getValidateToken = (refCode, emailUser) => {
  return async dispatch => {
    const tokenData = await axios.get(
      `${process.env.REACT_APP_API_PATH_MAYAHII_USER_DATA}/validate/code/password`,
      {
        params: {
          refCode,
          emailUser
        }
      }
    );
    if (tokenData.data.response) {
      dispatch(
        recoverAccountDataActions.token({
          tokenInfo: true
        })
      );
    } else {
      dispatch(
        recoverAccountDataActions.token({
          tokenInfo: 'noToken'
        })
      );
    }
    return false;
  };
};

export const getChangePassword = async (
  token,
  newPassword,
  passConf,
  emailUser
) => {
  const changePasswordData = await axios.post(
    `${process.env.REACT_APP_API_PATH_MAYAHII_USER_DATA}/change/password/code`,
    {
      token,
      newPassword,
      passConf,
      emailUser
    }
  );
  if (changePasswordData.data) {
    logIn(emailUser, newPassword);
    return true;
  }
  return 'error';
};
